<div class="article-container padding-x-m">
  @for (item of content; track $index) {
  @switch (item.type) {
  @case ('markdown') {
  <div class="article-section">
    <!--           @if (editable) {
            <button class="edit-section-btn" (click)="startEditing($index, item.data)" title="Editar sección">
              <img src="assets/icons/edit.svg" class="icon-16 icon-gray-600" alt="Edit">
            </button>
          } -->
    <app-markdown-viewer [data]="item.data" [collapsibleHeaders]="true" [openLinksInNewTab]="true">
    </app-markdown-viewer>
  </div>
  }
  @case ('innerHTML') {
  <div class="article-html" [innerHTML]="item.data"></div>
  }
  @case ('map') {
  <div class="article-map">
    <app-maplibre-map [initialPosition]="item.data?.point" [config]="getMapConfig(item.data)"></app-maplibre-map>
  </div>
  }
  @case ('points') {
  <div class="article-points">
    @for (point of item.data; track point.id) {
    <app-recycling-point-card [point]="point"></app-recycling-point-card>
    }
  </div>
  }
  @case ('pills') {
  <div class="article-pills">
    <app-materials-pills [displayOnly]="true" [displayMaterials]="item.data" [pillSize]="'sm'">
    </app-materials-pills>
  </div>
  }
  @case ('button') {
  <div class="article-button push-btn full-width-button btn-m primary-color-button">
    <button class='inner-button primary-color-button p-bold' [class]="item.data?.cssClass || '' "
      (click)="buttonClick.emit({ action: item.data?.action, index: $index })">
      {{ item.data?.text || ('article.defaultButton' | t) }}
    </button>
  </div>
  }
  }
  }
</div>